import { createActions, createReducer } from 'reduxsauce'

import ConsultaListaObrasParadasService from '../../servicos/ConsultaListaObrasParadasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaListaObrasParadasInicio: [],
    buscaConsultaListaObrasParadasErro: ['erro'],
    buscaConsultaListaObrasParadasSucesso: ['consultaListaObrasParadas'],
    limpar: [],
    setConsultaListaObrasParadasEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaListaObrasParadas = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaListaObrasParadasInicio())
        let serv = new ConsultaListaObrasParadasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaListaObrasParadasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaListaObrasParadasErro(error)))
    }
}

const buscaConsultaListaObrasParadasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaListaObrasParadasErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaListaObrasParadasSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaListaObrasParadas.resultado,
        dataSincronizacaoDados: action.consultaListaObrasParadas.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaListaObrasParadasEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_LISTA_OBRAS_PARADAS_INICIO]: buscaConsultaListaObrasParadasInicio,
    [Types.BUSCA_CONSULTA_LISTA_OBRAS_PARADAS_SUCESSO]: buscaConsultaListaObrasParadasSucesso,
    [Types.BUSCA_CONSULTA_LISTA_OBRAS_PARADAS_ERRO]: buscaConsultaListaObrasParadasErro,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_LISTA_OBRAS_PARADAS_ESTADO_DT]: setConsultaListaObrasParadasEstadoDT,
})
